import { STRINGS, VALIDATION_MESSAGES, EMAIL_REGX, PROMO_REGX } from '../../shared/constants';

const validator = values => {
  const errors = {};
  if (!values[STRINGS.CODE_NAME]) {
    errors[STRINGS.CODE_NAME] =
      VALIDATION_MESSAGES.NAME_REQUIRED;
  }
  else if (values[STRINGS.CODE_NAME] && !(values[STRINGS.CODE_NAME].trim())) {
      errors[STRINGS.CODE_NAME] =
      VALIDATION_MESSAGES.NAME_REQUIRED;
  }
  else if (
    !PROMO_REGX.test(
      values[STRINGS.CODE_NAME]
    )
  ) {
    errors[STRINGS.CODE_NAME] =
      VALIDATION_MESSAGES.PROMO_CODE_INVALID;
  }
    
    
    if (!values[STRINGS.EMAIL_INPUT_NAME]) {
    errors[STRINGS.EMAIL_INPUT_NAME] =
      VALIDATION_MESSAGES.EMAIL_REQUIRED;
  } else if (
    !EMAIL_REGX.test(
      values[STRINGS.EMAIL_INPUT_NAME].toLowerCase()
    )
  ) {
    errors[STRINGS.EMAIL_INPUT_NAME] =
      VALIDATION_MESSAGES.EMAIL_INVALID;
  }
    
    
  if (!values[STRINGS.PASSWORD_INPUT_NAME]) {
    errors[STRINGS.PASSWORD_INPUT_NAME] =
      VALIDATION_MESSAGES.PASSWORD_REQUIRED;
  }

  return errors;
};

export default validator;
